import {Tag as AntdTag} from 'antd';
import styles from './touchTag.module.scss';

const TouchTag = ({closable, children, ...props}) => (
  <div
    className={styles.touchTag}
  >
    <AntdTag
      style={{padding: closable ? 0 : '10px'}}
      closable={closable}
      {...props}
    >
      <span>{children}</span>
    </AntdTag>
  </div>
);
export default TouchTag;
